import { connect } from "react-redux";

import { RootState } from "store/store";

import { setModalLoaderVisibility } from "store/common/modal-window/modal-window-slices";
import { setErrorResponseMessage } from "store/common/initialization/initialization-actions";

import {
    getCustomerId,
    getIsHistoryOpened,
} from "store/customers/customers-selectors";
import { setIsCustomerHistoryOpened } from "store/customers/customers-actions";

import CustomerHistory from "./CustomerHistory";

const mapStateToProps = (state: RootState) => ({
    isOpened: getIsHistoryOpened(state),
    customerId: getCustomerId(state),
});

const CustomerHistoryContainer = connect(mapStateToProps, {
    setModalLoaderVisibility,
    setErrorResponseMessage,
    setIsCustomerHistoryOpened,
})(CustomerHistory);

export default CustomerHistoryContainer;
